export const enableLatency = (message = 'RESTART CHECKOUT-STUBS TO DISABLE LATENCY') => {
  const url = 'http://localhost:9000/chaos/activate/new';

  const headers = {
    'Content-Type': 'application/json',
  };

  const data = [
    {
      type: 'repeat',
      stages: [
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT0.2S',
            max: 'PT0.3S',
          },
          trigger: {
            type: 'request',
            method: 'get',
            path: '^((?!/\\.well-known/jwks\\.json).)*$',
          },
        },
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT0.3S',
            max: 'PT0.5S',
          },
          trigger: {
            type: 'request',
            method: 'get',
            path: '^((?!/api/v1/collectionpoints).)*$',
          },
        },
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT0.2S',
            max: 'PT0.3S',
          },
          trigger: {
            type: 'request',
            method: 'post',
            path: '^((?!/v1/baskets).)*$',
          },
        },
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT0.6S',
            max: 'PT0.8S',
          },
          trigger: {
            type: 'request',
            method: 'post',
            path: '^((?!/v1/delivery-propositions).)*$',
          },
        },
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT0.4S',
            max: 'PT0.6S',
          },
          trigger: {
            type: 'request',
            method: 'post',
            path: '^((?!/v1/fulfilment-summary).)*$',
          },
        },
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT0.4S',
            max: 'PT0.9S',
          },
          trigger: {
            type: 'request',
            method: 'post',
            path: '^((?!/ocp/v3/payments).)*$',
          },
        },
        {
          type: 'trigger',
          behaviour: {
            type: 'latency',
            min: 'PT2.5S',
            max: 'PT4.5S',
          },
          trigger: {
            type: 'request',
            method: 'post',
            path: '^((?!/v1/orders).)*$',
          },
        },
      ],
    },
  ];

  fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(data),
  })
    /* eslint-disable no-console */
    .then((response) => response.json())
    .then((result) => {
      console.log('Success:', result);
      console.warn(message);
    })
    .catch((error) => {
      console.error('Error:', error);
    });
};
